import { Field, ErrorMessage } from "formik"

export default function FieldsCobro({ values, setFieldValue, errors, touched, options }) {

    const { cargos = [], marcas = [], colores = [] } = options;

  //Rellenado automatico de campos de cargo
  const handleCargo = (e) => {
    setFieldValue('IdCargo', e.target.value);

    const [cargo = null] = cargos.filter(x => x.IdCargo === e.target.value);

    if (cargo){
        setFieldValue('Valor', Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cargo.Valor));
        setFieldValue('Semestre', cargo.Semestre);
    }else{
        setFieldValue('Valor', '');
        setFieldValue('Semestre', '');
    }

  }

  //Validación visual de correo electrónico
  const isEmailOk = (() => {
    if(touched.Email && touched.Email2 && values.Email !== values.Email2){
        return false;
    }
    return true;
  })();

  //Handle Marca
  const handleMarca = (e) => {
    setFieldValue('IdMarca', e.target.value);

    if (e.target.value === '80') {
        return setFieldValue('Marca', '');
    }

    const [ marca = null ] = marcas.filter(x => x.IdMarca === Number(e.target.value));
    setFieldValue('Marca', marca.Marca);
  }

    //Handle Color
    const handleColor = (e) => {
        setFieldValue('IdColor', e.target.value);
    
        if (e.target.value === '16') {
            return setFieldValue('Color', '');
        }
    
        const [ color = null ] = colores.filter(x => x.IdColor === Number(e.target.value));
        setFieldValue('Color', color.Color);
    }

    //Handle celular
    const handleCelular = (e) => {
        setFieldValue('Celular', e.target.value);

        const regex = /^[0-9]{0,8}$/;
        const isValid = regex.test(e.target.value);

        if (!isValid) {
            setFieldValue('Celular', e.target.value.slice(0, -1));
        }
    }

    return (
      <div className="flex flex-col gap-5">
        <fieldset className='col-span-6 lg:col-start-4 lg:col-span-3'>
          <div className="flex justify-between">    
              <label className="block text-sm font-medium text-grisMira shrink-0">
                  Datos del estudiante
              </label>
              <ErrorMessage component="p" name="Email2" className="w-full text-right block text-sm font-semibold text-red-500"/>
          </div>
          <div className="mt-1 -space-y-px rounded-md bg-white shadow-sm">
            <div>
              <label className="sr-only">
                Nombre
              </label>
              <Field
                type="text"
                name="Nombre"
                className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                placeholder="Nombre"
              />
            </div>
            <div className="flex -space-x-px">
              <div className="w-1/2 min-w-0 flex-1">
                <label className="sr-only">
                  Carnet
                </label>
                <Field
                  type="text"
                  name="Carnet"
                  className="relative block w-full rounded-none rounded-bl-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                  placeholder="Carnet"
                />
              </div>
              <div className="min-w-0 flex-1">
                <label className="sr-only">
                  Celular
                </label>
                <Field
                  onChange={handleCelular}
                  type="tel"
                  name="Celular"
                  className="relative block w-full rounded-none border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                  placeholder="Celular"
                />
              </div>
            </div>
            <div>
              <label className="sr-only">
                Correo electrónico
              </label>
              <Field
                type="email"
                name="Email"
                className={`
                    relative block w-full rounded-none bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm
                    ${!isEmailOk ? 'border-2 border-red-500' : 'border-gray-300'}
                `}
                placeholder="Correo electrónico"
              />
            </div>
            <div>
              <label className="sr-only">
                Correo electrónico 2
              </label>
              <Field
                type="email"
                name="Email2"
                className={`
                    relative block w-full rounded-none rounded-b-md bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm
                    ${!isEmailOk ? 'border-2 border-red-500' : 'border-gray-300'}
                `}
                placeholder="Ingrese de nuevo el correo electrónico"
              />
            </div>
          </div>
        </fieldset>

        <fieldset className='lg:row-start-2 col-span-6 lg:col-span-3'>
          <legend className="block text-sm font-medium text-grisMira">Datos del recibo</legend>
          <div className="mt-1 -space-y-px rounded-md bg-white shadow-sm">
            <div> 
              <label className="sr-only">
                Cargo
              </label>
              <Field
                onChange={handleCargo}
                name="IdCargo"
                as="select"
                className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value=''>----SELECCIONE UN CARGO-----</option>
                {cargos.map((cargo, idx) => <option key={idx} value={cargo.IdCargo}>{cargo.Cargo}</option>)}
              </Field>
            </div>
            <div className="flex -space-x-px">
              <div className="w-1/2 min-w-0 flex-1">  
                <label className="sr-only">
                    Semestre
                </label>
                <Field
                    readOnly
                    type="text"
                    name="Semestre"
                    className="relative block w-full rounded-none rounded-bl-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                    placeholder="Semestre"
                />
              </div>
              <div className="min-w-0 flex-1">
                <label className="sr-only">
                    Valor
                </label>
                <Field
                    readOnly
                    type="text"
                    name="Valor"
                    className="relative block w-full rounded-none rounded-br-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                    placeholder="Valor"
                />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className='lg:row-start-2 col-span-6 lg:col-span-3'>
            <div className="flex justify-between">    
              <label className="block text-sm font-medium text-grisMira shrink-0">
                  Datos del vehiculo
              </label>
              <ErrorMessage component="p" name="Placa" className="w-full text-right block text-sm font-semibold text-red-500"/>
            </div>
          <div className="grid grid-cols-6 mt-1 -space-y-px rounded-md bg-white shadow-sm">
            <div className="col-span-full">
                <label className="sr-only">
                    Placa
                </label>
                <Field
                    type="text"
                    name="Placa"
                    className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                    placeholder="No. Placa"
                />
            </div>
            <div className={values.IdColor === "16" && values.IdMarca !== "80" ? 'col-span-full' : 'col-span-3'}> 
              <label className="sr-only">
                Marca
              </label>
              <Field
                onChange={handleMarca}
                name="IdMarca"
                as="select"
                className="relative block w-full rounded-none rounded-bl-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value=''>----SELECCIONE UNA MARCA-----</option>
                {marcas.map((marca, idx) => <option key={idx} value={marca.IdMarca}>{marca.Marca}</option>)}
              </Field>
            </div>
            {
                values.IdMarca === "80"
                    ?   <div className="col-span-3">
                            <label className="sr-only">
                                Otra marca
                            </label>
                            <Field
                                type="text"
                                name="Marca"
                                className="relative block w-full rounded-none rounded-r-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                                placeholder="Otra marca"
                            />
                        </div>
                    : null
            }
            <div className={values.IdColor !== "16" && values.IdMarca === "80" ? 'col-span-full' : 'col-span-3'}>  
                <label className="sr-only">
                    Color
                </label>
                <Field
                    onChange={handleColor}
                    name="IdColor"
                    as="select"
                    className="relative block w-full rounded-none rounded-br-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                >
                    {colores.map((color, idx) => <option key={idx} value={color.IdColor}>{color.Color}</option>)}
                </Field>
            </div>
            {
                values.IdColor === '16'
                    ?   <div className="col-span-3">
                            <label className="sr-only">
                                Otro color
                            </label>
                            <Field
                                type="text"
                                name="Color"
                                className="relative block w-full rounded-none rounded-r-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                                placeholder="Otro color"
                            />
                        </div>
                    : null
            }
          </div>
        </fieldset>

        {
          Object.values(errors).length > 0 ?
            <p className="col-span-full w-full text-center block text-sm font-semibold text-red-500">Rellene todos los campos!</p>
          : null
        }
      </div>
    )
  }